import script from "./CmsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CmsView.vue?vue&type=script&setup=true&lang=js"

import "./CmsView.vue?vue&type=style&index=0&id=3d2aa779&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d2aa779"]])

export default __exports__